import React from 'react';

const ActivitiesPublicCleaning = () => {
  return (
    <section id="activities-public-cleaning">

      <h1>Köztisztasági telep</h1>

      <div>

        <header id="activities-public-cleaning-info">

          <h2>Nyitva tartás:</h2>
          <ul>
            <li>H-P 8-11 14-18</li>
            <li>Sz 7-8 12-13</li>
            <li>V 7-8</li>
          </ul>

          <h2>Dögész:</h2>
          <ul>
            <li>Rézműves Lajos</li>
          </ul>

          <h2>Elérhetőség:</h2>
          <ul>
            <li><a href="tel: +36 30/307-1455">30/307-1455</a></li>
          </ul>

        </header>
        
        <div id="activities-public-cleaning-img"></div>
    
        <div id="activities-public-cleaning-text">
          <p className="no-indent">
          2013. március 1-jétől a köztisztasági telep üzemeltetése is feladatunk. 
          <br/>
          A tevékenység keretén belül a város területén keletkező állati tetemeket begyűjtjük, illetve biztosított a helyszíni átvétel lakosok és közületek részére.
          <br/>
          A lakossági hulladékot térítés nélkül, gazdálkodó szervektől térítés ellenében vesszük át. Az így összegyűlt tetemeket az ATEV-vel kötött szerződés keretei között elszállíttatjuk heti 2-3 alkalommal.
          </p>
          <p>
            A telep működéséhez 1 fő megfelelő végzettségű munkavállaló áll rendelkezésünkre. Az összegyűjtött, illetve elszállított tetemek után MVH-s támogatást tudunk igénybe venni. 
          </p>
          <p>
            Az önkormányzat és más hatóságok ide vonatkozó rendeleteit betartjuk. 
          </p>
        </div>

      </div>

    </section>
  );
};

export default ActivitiesPublicCleaning;